import { render } from "./MemberDetail.vue?vue&type=template&id=54c5a95f&scoped=true"
import script from "./MemberDetail.vue?vue&type=script&lang=js"
export * from "./MemberDetail.vue?vue&type=script&lang=js"

import "./MemberDetail.vue?vue&type=style&index=0&id=54c5a95f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c5a95f"]])

export default __exports__